module.exports = __webpack_public_path__ + "img/8373228.gif";